import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { StepResult } from "src/app/interfaces";

@Component({
    selector: "step-result-icon",
    templateUrl: "./../step-icon.component.html",
    styleUrls: ["./../step-icon.component.scss"],
    standalone: false
})
export class StepResultIconComponent implements OnInit, OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (typeof changes["result"] === "undefined") {
      return;
    }

    this.setStatusImage();
  }
  @Input() public result: StepResult;
  @Input() public title = "";

  public statusImage: string;
  ngOnInit(): void {
    this.setStatusImage();
  }

  private setStatusImage(): void {
    this.statusImage = null;

    switch (this.result) {
      case "Confirmed":
        this.statusImage = "check-outline";
        break;
      case "Forwarded":
        this.statusImage = "forward";
        break;
      case "Rejected":
        this.statusImage = "close-outline";
        break;
      case "NotRequired":
        this.statusImage = "cancel-outline";
        break;
    }
  }
}
